<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="dark" v-if="isAuth">
      <b-navbar-brand href="#" class="text-uppercase">Видеонаблюдение ГИА</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" class="p-0">
        <font-awesome-icon :icon="['fas', 'bars']"></font-awesome-icon>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item :to="{ name: 'Main' }" v-show="canOgeOnline || canEgeOnline"><font-awesome-icon :icon="['fas', 'broadcast-tower']"></font-awesome-icon> Трансляция</b-nav-item>
          <b-nav-item  :to="{ name: 'News' }" v-show="canSeeNews">
            <font-awesome-icon :icon="['fas', 'newspaper']"></font-awesome-icon> Новости
          </b-nav-item>
          <b-nav-item  :to="{ name: 'Archive' }" v-show="canOgeArchive || canEgeArchive">
            <font-awesome-icon :icon="['fas', 'calendar-alt']"></font-awesome-icon> Архив
          </b-nav-item>
          <b-nav-item  :to="{ name: 'List' }" v-show="canViewViolations">
            <font-awesome-icon :icon="['fas', 'bell']"></font-awesome-icon> Нарушения
          </b-nav-item>
          <b-nav-item href="#" title="Выйти из системы" @click.prevent="logout()">
            <font-awesome-icon :icon="['fas', 'user']"></font-awesome-icon>
            {{ userInfo.name }}
            <font-awesome-icon :icon="['fas', 'sign-out-alt']"></font-awesome-icon>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="container-fluid">
      <router-view/>
    </div>
  </div>
</template>

<script>
  import Vuex from 'vuex';

  export default {
    name: "Index",
    computed: {
      ...Vuex.mapGetters([
        'userInfo',
        'isAuth',
        'isSearch',
        'canOgeOnline',
        'canEgeOnline',
        'canOgeArchive',
        'canEgeArchive',
        'canSeeNews',
        'canViewViolations',
        'role'
      ]),
    },
    methods: {
      ...Vuex.mapActions([
        'logout'
      ]),

    }
  }
</script>

